import { getAuth, signOut } from 'firebase/auth';

function logOut() {
  signOut(getAuth())
    .then(() => {
      localStorage.removeItem('userNudosData');
      localStorage.removeItem('_userInfo');
    })
    .catch(error => console.error('Error logging out:', error));
}

function domainMigrationRedirect() {
  const hostname = window.location.hostname;
  const OLD_HOST_DOMAIN = 'nudos.co';
  const OLD_HOST_SUBDOMAIN = 'soga';

  const isOldDomain = hostname.includes(OLD_HOST_DOMAIN) && hostname.includes(OLD_HOST_SUBDOMAIN);
  const findNewDomainEnvironment = () => {
    if (hostname.includes('test')) {
      return 'https://test.soga.bord.co';
    } else if (hostname.includes('beta')) {
      return 'https://beta.soga.bord.co';
    } else {
      return 'https://soga.bord.co';
    }
  };
  const NEW_HOST = findNewDomainEnvironment();

  if (isOldDomain) {
    logOut();
    const target = NEW_HOST + window.location.pathname + window.location.search + window.location.hash;

    window.location.replace(target);
  }
}

export default domainMigrationRedirect;
